import { render, staticRenderFns } from "./DataBox.vue?vue&type=template&id=e423880e&scoped=true"
import script from "./DataBox.vue?vue&type=script&lang=ts"
export * from "./DataBox.vue?vue&type=script&lang=ts"
import style0 from "./DataBox.vue?vue&type=style&index=0&id=e423880e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e423880e",
  null
  
)

export default component.exports